// extracted by mini-css-extract-plugin
module.exports = {"helloSection":"HelloSection-module--helloSection--kz-Ua","name":"HelloSection-module--name--3rDcV","title":"HelloSection-module--title--3vw6X"};